module.exports = __webpack_public_path__ + "img/strategic-1.05c3ecc7.png";